import request from "@/request";

export async function getBillboard(){
	const res = await request({
    url: "/billboards",
		method: 'get'	
	});

	return res.data
}
